import { render, staticRenderFns } from "./HospitalNotice.vue?vue&type=template&id=a21e76d4&scoped=true&"
import script from "./HospitalNotice.vue?vue&type=script&lang=js&"
export * from "./HospitalNotice.vue?vue&type=script&lang=js&"
import style0 from "./HospitalNotice.vue?vue&type=style&index=0&id=a21e76d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21e76d4",
  null
  
)

export default component.exports